<template>
  <div class="pay">
    <van-nav-bar
      title="请假"
      left-text="返回"
      right-text="请假记录"
      left-arrow
      @click-left="$router.go('-1')"
      @click-right="$router.push('leave-list')"
    />

    <div class="c-container1">
      <div class="c-margin-top-normal"></div>
      <CTitle title="开始时间：" />
      <div class="flex">
        <van-field
          readonly
          clickable
          name="datetimePicker"
          class="c-margin-top-normal"
          :value="time_begin"
          placeholder="开始时间"
          right-icon="arrow"
          @click="showTimeBegin = true"
        />
       
      </div>

      <div class="topMd"></div>
      <CTitle title="结束时间：" />
      <div class="flex">
        <van-field
          readonly
          clickable
          class="c-margin-top-normal"
          name="datetimePicker"
          :value="time_end"
          placeholder="结束时间"
          right-icon="arrow"
          @click="showTimeEnd = true"
        />
       
      </div>
      <div class="topMd"></div>
      <CTitle title="请假时长：" />
      <div class="flex">
        <van-field
          readonly
          class="c-margin-top-normal"
          name="qingjiatimelong"
          :value="time_long"
         
        />
       
      </div>
      <div class="topMd"></div>
      <CTitle title="请假类型：" />
      <div class="flex">
        <van-cell is-link  :title="leavename" @click="show = true"  />
<van-action-sheet v-model="show" :actions="actions" @select="onSelect" />
       
      </div>
      <div class="topMd"></div>
      <CTitle title="请假理由：" />
      <div class="flex">
        <van-field
  v-model="reasoncontent"
  rows="2"
  autosize
  label=""
  type="textarea"
  maxlength="50"
  placeholder="请输入理由"
  show-word-limit
/>
       
      </div>
    </div>

    <van-popup v-model="showTimeBegin" position="bottom">
      <van-datetime-picker
        v-model="pickerBeginTime"
        type="datetime"
        title="开始时间"
        @confirm="changeBeginTime"
        @cancel="showTimeBegin = false"
      />
    </van-popup>
    <van-popup v-model="showTimeEnd" position="bottom">
      <van-datetime-picker
        v-model="pickerEndTime"
        type="datetime"
        title="结束时间"
        @confirm="changeEndTime"
        @cancel="showTimeEnd = false"
      />
    </van-popup>

    <div style="margin-top: 40px">
      <van-button class="commonBtn" type="primary" block @click="handleSave">提交</van-button>
    </div>
  </div>
</template>

<script>
import { NavBar, NoticeBar, Toast,ActionSheet,Cell  } from 'vant'
import CCard from '@/components/c-card.vue'
import CTitle from '@/components/c-title'

export default {
  data() {
    return {
      showTimeBegin: false,
      showTimeEnd: false,
      reasoncontent:"",
      time_begin: '',
      time_end: '',
      leavename:"",
      leavetype:0,
      pickerBeginTime: new Date(),
      pickerEndTime: new Date(),

      beginRadio: '0',
      endRadio: '0',
      show:false,
      studentInfo:{},
      actions: [{ name: '病假',value:1 }, { name: '事假',value:2 }, { name: '其他',value:3 }],
      list: []
    }
  },
  computed:{
    time_long(){
      if(this.time_begin=="" || this.time_end==""){
        return ""
      }
      var s1 =new Date(this.time_begin.replace(/-/g,'/'))
      var s2=new Date(this.time_end.replace(/-/g,'/'))
      var total =(s2.getTime()-s1.getTime()) / 1000/3600
      var day = Math.floor(total / 24)
      var hours = total % 24 
      var stimes =''
      if (day==0){
        stimes= hours + " 小时" 
      }else {
        if (hours==0){
          stimes = day + " 天"
        }else {
          stimes = day +" 天 "+ hours +" 小时 "
        }
      }
      return stimes
    }
  },
  created() {
    
  },
  mounted(){
    var sinfo = localStorage.getItem("currentChild");
        this.studentInfo = JSON.parse(sinfo);
        if(this.studentInfo.Studentid==""){
          Toast("未选定孩子")
          this.$router.push("/my");
          return;
        }
  },
  methods: {
    onSelect(item){
      this.show =false;
      this.leavename=item.name;
      this.leavetype=item.value;
     
    },
    // 点击按钮保存
    handleSave() {
      if (this.leavetype==0) {
        Toast("请选择请假类型")
        return
      }
      if(this.time_begin=="" || this.time_end==""){
        Toast("请选择请假时间")
        return
      }
      this.$http
        .json_post(this.$api.leave.studentqingjia, {
          Studentid: eval(this.studentInfo.Studentid),
          Studentname:this.studentInfo.Studentname,
          Schoolid:eval(this.studentInfo.Schoolid),
          Schoolname:this.studentInfo.Schoolname,
          Gradeid:eval(this.studentInfo.Gradeid),
          Gradename:this.studentInfo.Gradename,
          Classid:eval(this.studentInfo.Classid),
          Classname:this.studentInfo.Classname,
          Relationname:this.studentInfo.Relationname,
          Leavetype: this.leavetype, //
          Leavestattime:this.time_begin,
          Leaveendtime:this.time_end,
          Leavereason:this.reasoncontent,
          Status:0
        })
        .then(data => {
          if (data.code == 0) {
            Toast('请假成功')
            this.$router.push('leave-list')
          }else{
            Toast(data.msg)
          }
        })
    },

    changeBeginTime(val) {
      var year = val.getFullYear()
      var month = val.getMonth() + 1
      var day = val.getDate()
      var hour=val.getHours()
      var minute=val.getMinutes()
      if (month >= 1 && month <= 9) {
        month = `0${month}`
      }
      if (day >= 1 && day <= 9) {
        day = `0${day}`
      }
      if (hour <10) {
        hour = `0${hour}`
      }
      if (minute <10) {
        minute = `0${minute}`
      }
    this.time_begin = `${year}-${month}-${day} ${hour}:${minute}`
  
      this.showTimeBegin = false
    },

    changeEndTime(val) {
      var year = val.getFullYear()
      var month = val.getMonth() + 1
      var day = val.getDate()
      var hour=val.getHours()
      var minute=val.getMinutes()
      if (month >= 1 && month <= 9) {
        month = `0${month}`
      }
      if (day >= 1 && day <= 9) {
        day = `0${day}`
      }
      if (hour <10) {
        hour = `0${hour}`
      }
      if (minute <10) {
        minute = `0${minute}`
      }
    this.time_end = `${year}-${month}-${day} ${hour}:${minute}`
  
      this.showTimeEnd = false
    },

    // 获取学生信息
    getStudnetInfo() {
      this.$http
        .json_post(this.$api.my.studentInfo, {
          student_id: localStorage.getItem('studentId'),
          pageNo: 1,
          pageSize: 1
        })
        .then(data => {
          if (data.code == 200) {
            const date = data.result.data[0].mute_time
            this.list = this.stringToArr(date)
          }
        })
    },
    stringToArr(str) {
      var weekArr = ['', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日']
      var retArr = new Array()
      var strings = str.split(';')
      for (var i = 0; i < strings.length; i++) {
        var model = {}
        var strs1 = strings[i].split('|')
        var strs2 = strs1[0].split(',')
        var strs3 = strs1[1].split(',')
        model.beiginName = weekArr[parseInt(strs2[0])]
        model.endName = weekArr[parseInt(strs2[1])]
        model.begin = strs3[0]
        model.end = strs3[1]
        retArr[i] = model
      }
      return retArr
    }
  },
  components: {
    'van-nav-bar': NavBar,
    'van-notice-bar': NoticeBar,
    'c-card': CCard,
    Toast,
    CTitle
  }
}
</script>

<style lang="scss" scoped>
.pay-row-item {
  line-height: 20px;
  .pay-row-item__title {
    display: inline-block;
    width: 70px;
    color: $text-secondary-color;
  }
}
.w300 {
  margin-left: 10px;
  width: 220px;
}
</style>
